import React from "react";
import { useTable } from "./Table";
import TableButton from "./TableButton";

const ResetFilters = ({ setResetKey,tableName }) => {
  const { onResetFilters } = useTable();

  return (
    <TableButton
      onClick={() => {
        onResetFilters();
        setResetKey((prev) => (prev += 1));
      }}
      className={`order-2 ${tableName === 'LookupTable' ? 'text-[#D30039] border border-[#D30039] rounded-md font-medium px-[22px] whitespace-nowrap ml-[10px] w-full' : ''}`}
    >
     {tableName === 'LookupTable' ? 'CLEAR FIELDS' :'Reset' }
    </TableButton>
  );
};

export default ResetFilters;
